import ApiService from "./axios/Apiservices";

export const getALLblog = async () => {
    return ApiService.get("/Bloglist");
};
export const getBlog = async (id) => {
    return ApiService.get(`/showblog/${id}`);
};